import { MultiSearchQueryWithFederation } from 'meilisearch';
import { SearchCollection } from './interfaces/search.interface';

export interface CollectionQuery {
  search: string;
  collections: SearchCollection[];
}

const mapMulti =
  (query: CollectionQuery) =>
  (col: SearchCollection): MultiSearchQueryWithFederation => ({
    indexUid: col.value,
    q: query.search,
    attributesToHighlight: ['*'],
    highlightPreTag: '<strong>',
    highlightPostTag: '</strong>',
    federationOptions: {
      weight: col.weight,
    },
  });

export function searchQueryBuilder(query: CollectionQuery): MultiSearchQueryWithFederation[] {
  const result = query.collections.map(mapMulti(query));
  return result;
}
